import { defineStore } from 'pinia'

export const useRegistrationsStore = defineStore('registrationStore', {
  state: () => {
    return {
      registered: false
    }
  },
  actions: {
    setRegistered() {
      this.registered = true
    },
    clearUser() {
      this.registered = false
    }
  },
  getters: {
    isRegistered: (state) => state.registered
  }
})
